import { Calendar } from "@fullcalendar/core";
import timeGridPlugin from "@fullcalendar/timegrid";
import twLocale from "@fullcalendar/core/locales/zh-tw";
import { Sweet } from "./sweetalert";
import { getCourseAdmin, getAdminClosed } from "./api";
import Params from "./getParams";


moment.defineLocale("zh-tw", {
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
});

document.addEventListener("DOMContentLoaded", function () {

  const calendarEl = document.getElementById("admin-calendar");
  let calendar = new Calendar(calendarEl, {
    plugins: [timeGridPlugin],
    initialView: 'timeGridWeek',
    locale: twLocale,
    height: '100%',
    headerToolbar: {
      left: 'prev',
      center: 'title',
      right: 'next,timeGridWeek,timeGridFourDay',
    },
    views: {
      timeGridFourDay: {
        type: 'timeGrid',
        duration: { days: 4 },
        buttonText: '4天',
      },
    },
    titleFormat: { month: 'numeric', day: 'numeric' },
    slotLabelFormat: function (data) {
      const hourText = moment(data.date.marker)
        .subtract(8, 'hours')
        .format('HH:mm');
      return hourText.toString();
    },
    dayHeaderFormat: function (data) {
      const dayNum = moment(data.date.marker)
        .subtract(8, 'hours')
        .format('MM/DD');
      const dayText = moment(data.date.marker)
        .subtract(8, 'hours')
        .locale('zh-tw')
        .format('dd');
      return `${dayNum}${dayText}`;
    },
    slotMinTime: '08:00:00',
    slotMaxTime: '21:00:00',
    allDaySlot: false,
    eventContent: '',
    eventSources: [
      {
        events: function (fetchInfo, successCallback, failureCallback) {
            getCourseAdmin({
              params: {
                start: moment(fetchInfo.start).format("YYYY-MM-DD"),
                end: moment(fetchInfo.end).format("YYYY-MM-DD"),
                area: Params.area
              }
            })
            .then(function (response) {
              const res = response.data;
              successCallback(res);
            })
            .catch(function (error) {
              failureCallback(error);
            })
        },
        textColor: '#333',
        borderColor: '#b5c9bc',
      },
      {
        events: function (fetchInfo, successCallback, failureCallback) {
            getAdminClosed({
              params: {
                start: moment(fetchInfo.start).format("YYYY-MM-DD"),
                end: moment(fetchInfo.end).format("YYYY-MM-DD"),
              }
            })
            .then(function (response) {
              const res = response.data;
              successCallback(res);
            })
            .catch(function (error) {
              failureCallback(error);
            })
        },
        textColor: '#333',
        color: '#eeafaf',
      }
    ],
    eventClick: function (info) {
      const vmCalendar = this;
      if(info.event.title == '休館日'){
        info.jsEvent.preventDefault();
      }else {
        Sweet.courseAdminModal(vmCalendar, info.event);
      }
    },
    eventDidMount: function (info) {
      const slotBox = info.el.childNodes[0];
      const status = showStatus(info.event);
      const statusText = status ? `(${status})` : '';
      const enrollmentText = info.event.extendedProps.enrollment ? `(${info.event.extendedProps.enrollment}人已登記)` : '';
      const lauchedText = info.event.extendedProps.isLaunched === false ?  '(未上架)' : '';
      const brandText = info.event.extendedProps.brand ? `(${info.event.extendedProps.brand})` : '';
      const insertHTML = `<div class="course-title">${info.event.title}${enrollmentText}${lauchedText}${brandText}</div>
      <div class="teacher">${info.event.extendedProps.showTeacher ? info.event.extendedProps.teacher : ''}<span class="status">${statusText}<span></div>`;
      slotBox.insertAdjacentHTML('beforeend', insertHTML);
    },
  });

  calendar.render();
});

function showStatus(el){
  if (el.extendedProps.noStudentQuota) {
    return "額滿"
  }else{
    return ""
  }
}